import ApiService from '@/services/api';

// TYPES

export type TUpdatePlayerMemberCardPaths = {
  id: string | number;
};
export type TUpdatePlayerMemberCardBody = unknown;

export type TUpdatePlayerMemberCardMaterials = {
  paths?: TUpdatePlayerMemberCardPaths;
  body?: TUpdatePlayerMemberCardBody;
};

export type TUpdatePlayerMemberCardResponse = unknown;

// FUNCTION

export const updatePlayerMemberCard = async ({
  paths,
  body,
}: TUpdatePlayerMemberCardMaterials): Promise<TUpdatePlayerMemberCardResponse> => {
  const response = await ApiService.put(`/v1/api/admin/player-member-card/${paths?.id}`, body);
  return response.data;
};
